<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">

      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full lg:w-3/4 mb-base">
        <vx-card slot="no-body" class="my-1  text-center bg-primary-gradient greet-user">
                    <img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" >
                    <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175">
          <feather-icon icon="AwardIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
          <h1 class="mb-6 text-white">Welcome back {{ activeUserInfo.name }} {{ activeUserInfo.last_name}},</h1>
          <!-- <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">You have done </p> -->
        </vx-card>
      </div>

      <!-- CARD 2: SUBSCRIBERS GAINED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
          hideChart
          class=" mb-2"
          icon="UserIcon"
          icon-right
          :statistic="teachersCount"
          statisticTitle="Teachers"
          color="primary" />

        <statistics-card-line
          hideChart
          class=" mb-2"
          icon="UsersIcon"
          icon-right
          :statistic="studentsCount"
          statisticTitle="Students"
          color="danger" />
      </div>
    </div>

    <div class="vx-row mb-base">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <vx-card title="Recent classes" :refresh-content-action="true" @refresh="refreshRecentClasses">
          <div slot="no-body" class="mt-4" align="center">
            <vs-table :data="recentClasses" class="table-dark-inverted">
              <template slot="thead">
                <vs-th>Class ID</vs-th>
                <vs-th style="max-width:200px">Module</vs-th>
                <vs-th>Teacher sign</vs-th>
                <vs-th style="max-width:100px">Student / Teacher</vs-th>
                <vs-th>Feedback</vs-th>
                <vs-th>Student sign date</vs-th>
                <vs-th>Teacher sign date</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span>#{{tr['id']}}</span>
                  </vs-td>
                  <vs-td style="max-width:200px">
                    <span>{{tr['module']['name']}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].status" >
                    <span class="flex items-center px-2 py-1 rounded"><div class="h-3 w-3 rounded-full mr-2" :class="getteacherSignColor(tr)"></div></span>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <ul class="users-liked user-list">
                        <li v-if="(tr['student'])">
                            <vx-tooltip :text="getFullName(tr['student'])" position="bottom">
                                <vs-avatar @click="redirectToStudent(tr['student'])" :src="tr['student']['user_image']" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                            </vx-tooltip>
                        </li>
                        <li v-if="(tr['teacher'])">
                            <vx-tooltip :text="getFullName(tr['teacher'])" position="bottom">
                                <vs-avatar @click="redirectToTeacher(tr['teacher'])" :src="tr['teacher']['user_image']" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                            </vx-tooltip>
                        </li>
                    </ul>
                  </vs-td>
                  <vs-td>
                    <div  class="vx-row">
                      <p style="font-size: 20px;" v-for="(feedback, feedbackIndex) in tr.teacher_feedbacks" :key="feedbackIndex" v-html="getEmojiWithId(feedback.answer)"></p>
                    </div>
                  </vs-td>
                  <vs-td>
                    <span>{{tr['date']}}</span>
                  </vs-td>
                  <vs-td>
                    <span>{{ getSignDate(tr) }}</span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card title="">
          <vue-apex-charts ref="recentClassesCount" type="area" height="350" :options="recentClassesCount.chartOptions" :series="recentClassesCount.series"></vue-apex-charts>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="Number of completed classes by day for last 30 days">
          <vue-apex-charts ref="recentClassesBarChart" type="bar" height="350" :options="barChart.chartOptions" :series="barChart.series"></vue-apex-charts>
        </vx-card>
      </div>

      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="% of completed classes by day for last 30 days">
          <vue-apex-charts ref="recentClassesPieChart" type="pie" height="350" :options="pieChart.chartOptions" :series="pieChart.series"></vue-apex-charts>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card title="">
          <vue-apex-charts ref="mixedChart" type="area" height="350" :options="mixedChart.chartOptions" :series="mixedChart.series"></vue-apex-charts>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import moduleClassManagement from '@/store/class-management/moduleClassManagement.js'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import VueApexCharts from 'vue-apexcharts'
import apexChatData from './apexChartData.js'

export default {
  data() {
    return {
      apexChatData: apexChatData,
      recentClasses: [],
      studentsCount : 0,
      teachersCount : 0,
      activeUserInfo : JSON.parse(localStorage.getItem("userInfo")),
      dateRangeData : [],
      studentCountData : [],
      recentClassesCount: {
        series: [],
        chartOptions: {
          colors: ['#0052a1', '#A7006D', '#EA5455', '#FF9F43', '#1E1E1E'],
          chart: {
            stacked: false,
          },
          stroke: {
            width: [2, 2],
            curve: 'smooth'
          },
          plotOptions: {
            bar: {
              columnWidth: '50%'
            }
          },

          fill: {
            opacity: [1, 1, 1],
            gradient: {
              inverseColors: false,
              shade: 'light',
              type: "vertical",
              opacityFrom: 0.85,
              opacityTo: 0.55,
              stops: [0, 100, 100, 100]
            }
          },
          labels: [],
          markers: {
            size: 0
          },
          xaxis: {
            tooltip: {
              enabled: false
            },
            type: 'datetime',
            // labels: {
            //  format: 'MM yyyy'
            // }
          },
          yaxis: {
            tooltip: {
              enabled: false
            },
            title: {
                text: 'Number of completed classes last 30 days',
            },
            min: 0
          },
          tooltip: {
            enabled: false
          },
        }
      },
      mixedChart: {
        series: [],
        chartOptions: {
          colors: ['#0052a1', '#A7006D', '#EA5455', '#FF9F43', '#1E1E1E'],
          chart: {
            stacked: false,
          },
          stroke: {
            width: [2, 2],
            curve: 'smooth'
          },
          plotOptions: {
            bar: {
              columnWidth: '50%'
            }
          },

          fill: {
            opacity: [1, 1, 1],
            gradient: {
              inverseColors: false,
              shade: 'light',
              type: "vertical",
              opacityFrom: 0.85,
              opacityTo: 0.55,
              stops: [0, 100, 100, 100]
            }
          },
          labels: [],
          markers: {
            size: 0
          },
          xaxis: {
            type: 'datetime',
            tooltip: {
              format: 'MM yyyy'
            },
            // labels: {
            //  format: 'MM yyyy'
            // }
          },
          yaxis: {
            title: {
              text: 'Number of users signup',
            },
            min: 0
          },
          tooltip: {
            shared: true,
            intersect: false,
          }
        }
      },
      barChart: {
        series: [],
        chartOptions: {
          colors: ['#0052a1', '#0052a1', '#0052a1', '#0052a1', '#0052a1'],
          plotOptions: {
            bar: {
              horizontal: true,
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
          },
        }
      },
      pieChart: {
        series: [0, 0, 0, 0, 0, 0, 0],
        series: [],
        chartOptions: {
          labels: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
          // colors: ['#A7006D', '#0086A7', '#2BDD43', '#C1AF00', '#E1331F', '#F1CD64', '#0C36B8'],
          // responsive: [{
          //   breakpoint: 480,
          //   options: {
          //     chart: {
          //       width: 200
          //     },
          //     legend: {
          //       position: 'bottom'
          //     }
          //   }
          // }],
          dataLabels: {
            enabled: true
          },
          plotOptions: {
            pie: {
              size: 200
            }
          }
        }
      },
    }
  },
  components: {
    StatisticsCardLine,
    VueApexCharts
  },
  async mounted() {
    
  },
  async created() {
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    if(!moduleClassManagement.isRegistered) {
      this.$store.registerModule('classManagement', moduleClassManagement)
      moduleClassManagement.isRegistered = true
    }

    this.teachersCount = this.$store.state.userManagement.teachersCount
    this.studentsCount = this.$store.state.userManagement.studentsCount
    this.recentClasses = this.$store.state.classManagement.recentClasses

    var data = this.$store.state.userManagement.students,
      result = await data.reduce((r, { created_at }) => {
        var key = created_at.slice(0, 7);
        r[key] = (r[key] || 0) + 1;
        return r;
      }, {});

    var data = this.$store.state.userManagement.teachers,
        teacherResult = await data.reduce((r, { created_at }) => {
          var key = created_at.slice(0, 7);
          r[key] = (r[key] || 0) + 1;
          return r;
        }, {});

    var labelsArray = [];
    var valuesStudentsArray = [];
    var valuesTeachersArray = [];

    for (var i in result) {
      valuesStudentsArray.push(result[i])
      labelsArray.push(i)

      if(teacherResult[i]) valuesTeachersArray.push(teacherResult[i])
        else valuesTeachersArray.push(0)
    }

    this.$refs.mixedChart.updateOptions({
      labels : labelsArray
    });

    // var data = this.$store.state.userManagement.teachers,
    //     teacherResult = await data.reduce((r, { created_at }) => {
    //       var key = created_at.slice(0, 7);
    //       r[key] = (r[key] || 0) + 1;
    //       return r;
    //     }, {});

    // for (var i in result) {
    //   valuesTeachersArray.push(result[i])
    // }

    this.$refs.mixedChart.updateSeries([{
      name: 'Students',
      type: 'area',
      data: valuesStudentsArray
    },{
      name: 'Teachers',
      type: 'area',
      data: valuesTeachersArray
    }]);

    this.$store.dispatch("classManagement/fetchRecentClasses")
      .then(res => { 
        this.recentClasses = res.data
      })

    this.$store.dispatch("classManagement/fetchRecentClassesCount")
      .then(res => { 
        var recentClassesLablesArray = [];
        var recentClassesCountArray = [];
        let currentYear =  new Date().getFullYear();
        var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        var totalCount = [0, 0, 0, 0, 0, 0, 0];
        for(var i = 0; i < res.data.length; i++){
          const d = new Date(months[res.data[i].month-1]+" "+res.data[i].date+", "+currentYear);
          let day = d.getDay();

          switch(day) {
            case 0:
              totalCount[0] = totalCount[0]+res.data[i].classes
              break;
            case 1:
              totalCount[1] = totalCount[1]+res.data[i].classes
              break;
            case 2:
              totalCount[2] = totalCount[2]+res.data[i].classes
              break;
            case 3:
              totalCount[3] = totalCount[3]+res.data[i].classes
              break;
            case 4:
              totalCount[4] = totalCount[4]+res.data[i].classes
              break;
            case 5:
              totalCount[5] = totalCount[5]+res.data[i].classes
              break;
            case 6:
              totalCount[6] = totalCount[6]+res.data[i].classes
              break;
            default:
              // code block
          }

          recentClassesLablesArray.push(res.data[i].date+"-"+res.data[i].month_text)
          recentClassesCountArray.push(res.data[i].classes)
        }

        this.$refs.recentClassesCount.updateOptions({
          labels : recentClassesLablesArray
        });

        this.$refs.recentClassesCount.updateSeries([{
          name: 'Classes',
          type: 'area',
          data: recentClassesCountArray
        }]);

        this.$refs.recentClassesBarChart.updateOptions({
          labels : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
        });

        this.$refs.recentClassesBarChart.updateSeries([{
          data: totalCount
        }]);

        // this.pieChart.series = totalCount
        // this.pieChart.chartOptions = {
        //   labels: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
        //   colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E', '#5425F0', '#11C76F'],
        // };

        this.$refs.recentClassesPieChart.updateOptions({
          labels: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
          // colors: ['#A7006D', '#0086A7', '#2BDD43', '#C1AF00', '#E1331F', '#F1CD64', '#0C36B8'],
        });

        this.$refs.recentClassesPieChart.updateSeries(totalCount);
      })

    await this.$store.dispatch("userManagement/fetchTeachers")
      .then(res => { 
        this.teachersCount = res.data.length
      })

    await this.$store.dispatch("userManagement/fetchStudents")
      .then(res => { 
        this.studentsCount = res.data.length
      })

     var data = this.$store.state.userManagement.students,
        result = await data.reduce((r, { created_at }) => {
          var key = created_at.slice(0, 7);
          r[key] = (r[key] || 0) + 1;
          return r;
        }, {});

      var labelsArray = [];
      var valuesStudentsArray = [];
      var valuesTeachersArray = [];

      var data = this.$store.state.userManagement.teachers,
        teacherResult = await data.reduce((r, { created_at }) => {
          var key = created_at.slice(0, 7);
          r[key] = (r[key] || 0) + 1;
          return r;
        }, {});


      for (var i in result) {
        valuesStudentsArray.push(result[i])
        labelsArray.push(i)

        if(teacherResult[i]) valuesTeachersArray.push(teacherResult[i])
        else valuesTeachersArray.push(0)
      }

      this.$refs.mixedChart.updateOptions({
        labels : labelsArray
      });

      // for (var i in result) {
      //   valuesTeachersArray.push(result[i])
      // }

      this.$refs.mixedChart.updateSeries([{
        name: 'Students',
        type: 'area',
        data: valuesStudentsArray
      },{
        name: 'Teachers',
        type: 'area',
        data: valuesTeachersArray
      }]);

    // this.$store.dispatch("userManagement/studentsMonthWiseRegistation")
    //   .then(res => { 
    //     for(var i = 0; i < res.data.length; i++){
    //       this.dateRangeData.push(res.data[i].month_text+"-"+res.data[i].year)
    //       this.studentCountData.push(res.data[i].students)
    //     }
    //   })

    // this.line.xAxis = {
    //   data: this.dateRangeData
    // }

    // this.line.series = {
    //   type: 'line',
    //   showSymbol: false,
    //   data: this.studentCountData
    // }
  },
  methods: {
    getEmojiWithId(id){
      if(id == 1) return "&#128528;"
      else if(id == 2) return "&#128578;"
      else if(id == 3) return "&#128512;"
      else if(id == 4) return "&#129321;"
      return "";
    },
    redirectToStudent(tr) {
      this.$router.push("/students/" + tr['id']).catch(() => {})
    },
    redirectToTeacher(tr) {
      this.$router.push("/teachers/" + tr['id']).catch(() => {})
    },
    getSignDate(tr) {
      return (tr['signed_date']) ? tr['signed_date'] : '-'
    },
    getFullName(tr) {
      let firstName = (tr['name']) ? tr['name'] : ''
      let lastName = (tr['last_name']) ? tr['last_name'] : ''
      return firstName+' '+lastName
    },
    getteacherSignColor(tr) {
      if(tr['teacher_sign'] == '1') return 'bg-success'
      else return 'bg-danger'
    },
    getstudentSignColor(tr) {
      if(tr['student_sign'] == '1') return 'bg-success'
      else return 'bg-danger'
    },
    refreshRecentClasses(card) {
      this.$store.dispatch("classManagement/fetchRecentClasses")
      .then(res => { 
        this.recentClasses = res.data
        card.removeRefreshAnimation();
      })
      .catch(err => { 
        card.removeRefreshAnimation();
      })
    }
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
